module.exports = __webpack_public_path__ + "img/boundary-timer-event.3f60553b.svg";